import { useCallback, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import useIntl from '../../../hooks/useIntl';
import messages from './messages';

export const usePostPaymentsAndDepositsModal = ({ onMarkAsPaid }) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), []);

  const handleClose = useCallback(() => {
    if (isSubmitting) return;
    setOpen(false);
  }, [isSubmitting]);

  const handleConfirm = useCallback(async () => {
    setIsSubmitting(true);
    try {
      await onMarkAsPaid();
      toastr.success('Success', intl.formatMessage(messages.toastrSuccess));
      setOpen(false);
    } catch (e) {
      toastr.error(
        'Error',
        e?.message ?? e?.error ?? intl.formatMessage(messages.toastrError),
      );
    } finally {
      setIsSubmitting(false);
    }
  }, [onMarkAsPaid, intl]);

  const actionsProps = [
    {
      variant: 'text',
      children: intl.formatMessage(messages.cancel),
      onClick: handleClose,
      disabled: isSubmitting,
    },
    {
      children: intl.formatMessage(messages.confirm),
      onClick: handleConfirm,
      disabled: isSubmitting,
      isSubmitting,
      submitButton: true,
    },
  ];

  return {
    open,
    isSubmitting,
    handleOpen,
    handleClose,
    handleConfirm,
    actionsProps,
  };
};
